<template>

  <svg
    t="1639130538452"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3985"
    width="64"
    height="64"
  ><path d="M898.37632812 864.15470703L689.97587891 680.36389648c57.195-59.69522461 92.56860352-140.46477539 92.56860351-229.45324218 0-183.19139648-149.04272461-332.21074219-332.21162109-332.21074219-183.19139648 0-332.21074219 149.01925781-332.21074219 332.21074219 0 183.16801758 149.01925781 332.21162109 332.21074219 332.21162109 76.46756836 0 146.78463867-26.24396484 202.99324219-69.81301758l210.25168945 185.64389649c4.80603516 4.80603516 11.10243164 7.20896484 17.39882812 7.20896484 6.29551758 0 12.59191406-2.40301758 17.39786133-7.20896484C907.99006836 889.33941406 907.99006836 873.76853516 898.37632812 864.15470703zM167.34051758 450.91074219c0-156.03574219 126.93418945-282.99418945 282.99418945-282.99418946 156.03662109 0 282.99418945 126.95853516 282.99418945 282.99418946 0 156.05912109-126.95756836 282.99418945-282.99418945 282.99418945C294.27470703 733.90493164 167.34051758 606.96977539 167.34051758 450.91074219z" p-id="3986" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconSearch',
} as DefineComponent
</script>